import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';
import {SharedModule} from "@shared/shared.module";

@Component({
  selector: 'app-image-loading-modal',
  standalone: false,
  templateUrl: './image-loading-modal.component.html',
  styleUrls: ['./image-loading-modal.component.scss'],
})
export class ImageLoadingModalComponent implements OnDestroy {
  @Input() showMessageAfterMs = 3000;
  @Input() loadingMessage = 'Loading the high-resolution image into the viewer.<br />This may take a few moments.';

  @Output() cancel = new EventEmitter<void>();

  public isLoading = false;
  public showMessage = false;

  public play$ = new Subject<void>();
  public stop$ = new Subject<void>();

  private timeoutId: any;

  start(): void {
    this.isLoading = true;
    this.showMessage = false;

    this.play$.next();

    this.timeoutId = setTimeout(() => {
      if (this.isLoading) {
        this.showMessage = true;
      }
    }, this.showMessageAfterMs);
  }

  stop(): void {
    this.isLoading = false;
    this.showMessage = false;
    this.stop$.next();
    clearTimeout(this.timeoutId);
  }

  onCancel(): void {
    this.stop();
    this.cancel.emit();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }
}
